/** Zalo badge for the "Đăng nhập bằng Zalo" button. Inline so the login screen
 * pulls in no extra asset request on its critical path. */
export function ZaloMark({ className = 'h-5 w-5' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Zalo" focusable="false">
      <rect width="48" height="48" rx="12" fill="#0068FF" />
      <text
        x="24"
        y="31"
        textAnchor="middle"
        fill="#FFFFFF"
        fontFamily="'Be Vietnam Pro', system-ui, sans-serif"
        fontSize="17"
        fontWeight="700"
        letterSpacing="-0.5"
      >
        Zalo
      </text>
    </svg>
  );
}
